import React from "react";
import PropTypes from "prop-types";
import { PromiseState } from "react-refetch";
import saveAs from "file-saver";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import "../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";

import { cachingRefetchWithToken } from "../netzwerk/Refetch";
import { getPathexpectCSV } from "../netzwerk/FetchWithToken";

import "./Datenlogs.css";

const handleDownload = (item) => {
	getPathexpectCSV("/archive/" + item.path).then(response => {
		return response.text().then(text => {
			if (response.ok) {
				saveAs(new Blob([text], {type: "text/comma-separated-values"}), item.file);
			}
		});
	});
};

const DatenArchivInt = injectIntl(props => {
	const paginationOptions = {
		hideSizePerPage: true
	};
	if ((props.data[props.item] !== undefined) && (props.data[props.item].length > 0)) {
		return <React.Fragment>
			<FormattedMessage id={props.id}/>
			<BootstrapTable
				data={props.data[props.item]}
				options={paginationOptions}
				pagination>
				<TableHeaderColumn isKey dataField='file'
					dataFormat={(cell, row) => {
						return <p onClick={() => handleDownload(row)}>{cell}</p>;
					}}>
					<FormattedMessage id="File"/>
				</TableHeaderColumn>
				<TableHeaderColumn dataField='size' width="80">
					<FormattedMessage id="Size"/>
				</TableHeaderColumn>
			</BootstrapTable>
		</React.Fragment>;
	}
	else {
		return <div/>;
	}
});

DatenArchivInt.propTypes = {
	intl: intlShape.isRequired,
	item: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	data: PropTypes.array.isRequired
};

class Datenlogs extends React.Component {
	
	static propTypes = {
		today: PropTypes.instanceOf(Date),
		archiveFetch: PropTypes.instanceOf(PromiseState).isRequired,
		auth: PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			range: null,
			archive: []
		};
	}
	renderReady() {
		if (this.props.archiveFetch.fulfilled) {
			return <React.Fragment>
				<DatenArchivInt item="GLW" id="Master control" data={this.props.archiveFetch.value}/>
				<DatenArchivInt item="Comp" id="Compressor control" data={this.props.archiveFetch.value}/>
			</React.Fragment>;
		}
		return <p>loading</p>;
	}
	render() {
		return (
			<div className="Datenlogs">
				{/*<Zeitraum max_date={today} onRangeChanged={this.handleRangeChange} />*/}
				{/*<AlmigButton i18n_key="Download" onClick={this.handleDownload} />*/}
				{this.renderReady()}
			</div>
		);
	}
}

export default cachingRefetchWithToken(() => ({
	archiveFetch: { url: "/archive/available", refreshInterval: 10000 }
}))(Datenlogs);
